// import field.module.css in page where the component will added
import "./field.scss";
import MainStyle from "components/UI/main.module.scss"

import { Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

export const InputPassword = ({className,
                               icon_style,
                               icon_style_hover,
                               style,
                               placeholder,
                               defaultValue,
                               iconComponent,
                               children,
                               onChange,
                               name,
                               id,
                               value,
                               list,
                               maxLength}) => {
  return (
    <Input.Password
      className={className}
      icon_style={icon_style}
      icon_style_hover={icon_style_hover}
      style={style}
      placeholder={placeholder}
      prefix={iconComponent}
      onChange={onChange}
      defaultValue={defaultValue}
      name={name}
      id={id}
      value={value}
      list={list}
      maxLength={maxLength}
      iconRender={(visible) =>
        visible ? <EyeTwoTone className={MainStyle.btnEyePassword} /> : <EyeInvisibleOutlined className={MainStyle.btnEyePassword} />
      }
    >
      {children}
    </Input.Password>
  );
};

export const InputGeneral = ({
  className,
  type,
  placeholder,
  defaultValue,
  children,
  onChange,
  name,
  id,
  value,
  style,
  list,
  maxLength,
  autoSize
}) => {
  const CommonProps = {
    className,
    type,
    placeholder,
    defaultValue,
    children,
    onChange,
    name,
    id,
    value,
    style,
    list,
    maxLength    
  };
  return (
    autoSize ? 
      <Input.TextArea
        {...CommonProps}
        autoSize={autoSize}
      >
        {children}
      </Input.TextArea>
    :
      <Input
        {...CommonProps}
      >
        {children}
      </Input>
  );
};

export const disabledInput = ({
  className,
  type,
  placeholder,
  defaultValue,
  iconComponent,
  children,
  onChange,
  name,
  id,
  value,
  style,
  list
}) => {
  return (
    <Input
      className={className}
      style={style}
      type={type}
      placeholder={placeholder}
      prefix={iconComponent}
      onChange={onChange}
      defaultValue={defaultValue}
      name={name}
      id={id}
      value={value}
      list={list}
      disabled
    >
      {children}
    </Input>
  );
};

const Field = ({
  className,
  type,
  style,
  placeholder,
  defaultValue,
  iconComponent,
  children,
  onChange,
  name,
  id,
  value,
  list,
  disabled,
  maxLength
}) => {
  return (
    <>
      {type === "password" ? (
        <InputPassword placeholder={placeholder}></InputPassword>
      ) : (
        disabled == true ?
        (<Input
          className={className}
          type={type}
          style={style}
          placeholder={placeholder}
          iconComponent={iconComponent}
          onChange={onChange}
          defaultValue={defaultValue}
          name={name}
          id={id}
          value={value}
          list={list} 
          disabled
          maxLength={maxLength}
        >
        {children}
      </Input>):
        (<InputGeneral
          className={className}
          type={type}
          style={style}
          placeholder={placeholder}
          prefix={iconComponent}
          onChange={onChange}
          defaultValue={defaultValue}
          name={name}
          id={id}
          value={value}
          list={list} 
          maxLength={maxLength}
        >
        {children}
      </InputGeneral>)
      )}
    </>
  );
};

export default Field;
